module.exports = __webpack_public_path__ + "img/Summer-text.386f678a.jpg";